import PropTypes from 'prop-types'
import React from 'react'

const ToastClose = ({ closeToast }) => (
  <div className='toast-close-container'>
    <button type='button' className='close text-white' aria-label='Close' onClick={closeToast}>
      <span aria-hidden='true'>&times;</span>
    </button>
  </div>
)

ToastClose.propTypes = {
  closeToast: PropTypes.func
}

export default ToastClose
